<template>
  <!--  详情页 -->
  <div class="fourlist" @click="homeclick()">
    <!-- <div class="alltodo" ref="soncpnts" :style="{ backgroundColor: bgcolo }"> -->
    <div class="alltodo" ref="soncpnts" >
      <div class="nav" :class="fontcolor ? 'foncolor' : ''">
        <div class="nav-lt">
          <img
            v-if="fontcolor"
            class="nav-lt-img"
            src="../../assets/img/home/center/whole2.png"
            alt=""
            @click="displayleft"
          />
          <img
            v-else
            class="nav-lt-img"
            src="../../assets/img/home/center/whole.png"
            alt=""
            @click="displayleft"
          />

          <div class="nav-lt-tit" :style="getTheme()=='普通模式'?'color:#999;':'color:#000;'"    >{{ bgtet }}</div>
        </div>
        <div class="nav-rt">
          <el-switch
            class="nav-rt-sw"
            v-model="switchVal"
            :width="33"
            active-color="#13ce66"
            inactive-color="#bbbbbc"
            @change="switchChang"
          >
          </el-switch>
          <div class="nav-rt-txt">显示已完成</div>
        </div>
      </div>

      <div ref="heightCtr" class="height-cotr">
        <div class="alltodo_content">
          <div
            class="alltodo_outer"
            :class="deleLine == index ? 'delecls' : ''"
            v-for="(item, index) in itemdata"
            :key="index"
            v-show="
              switchVal
                ? !item.task_status || item.task_status
                : !item.task_status
            "
            :style="getTheme()=='普通模式'?'color:#000;':'color:#333;'"
            @click="todorigClick(item.id, item)"
          >
            <!-- :style="{ opacity: !item.task_status ? '' : '.6' }" -->
            <div class="alltodo_list">
              <i
                v-show="item.type == 0"
                :style="{ backgroundColor: '#ec7259' }"
              ></i>
              <i
                v-show="item.type == 1"
                :style="{ backgroundColor: '#f6a801' }"
              ></i>
              <i
                v-show="item.type == 2"
                :style="{ backgroundColor: '#b78efc' }"
              ></i>
              <i
                v-show="item.type == 3"
                :style="{ backgroundColor: '#90d034' }"
              ></i>
              <div>
                <img
                  @click.stop="chooseCheak(item, index)"
                  v-show="!item.task_status"
                  src="../../assets/img/home/center/uncomplete.png"
                  alt=""
                  class="min_img"
                />
                <img
                  v-show="item.task_status"
                  src="../../assets/img/home/center/complete.png"
                  alt=""
                  class="min_img"
                />
              </div>

              <div class="min_list">
                <span> {{ item.task_name }}</span>
                <div>
                  <p>{{ item.task_time }}</p>
                  <span>
                    <img
                      src="../../assets/img/home/center/repeat.png"
                      alt=""
                      v-show="item.task_repeat != 0"
                    />
                    <!-- <img src="../../assets/img/home/center/remind.png" alt="" /> -->
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="main_bt_img" v-show="itemdata.length == 0">
          <img src="../../assets/img/list/zw.png" alt="" />
        </div>
      </div>

      <!-- <div
        v-if="visible"
        class="idpop"
        :style="{ top: tranTop, left: tranLeft }"
      >
        <img src="../../assets/img/home/center/deleter.png" alt="" />
        <span>删除清单</span>
      </div> -->

      <div class="add_task" :class="fontcolor ? 'bgncolor' : ''">
        <img src="../../assets/img/home/center/add.png" alt="" />
        <input
          type="text"
          placeholder="添加任务"
          v-model="addbottom"
          @keyup.enter="submit"
        />
        <div v-if="addbottom != ''" class="add_task_right">
          <div class="newlybuild_time">
            <img src="../../assets/img/rightsideber/adddate.png" alt="" />
            <span style="width: 80px" v-if="value1 != ''">{{ value1 }}</span>
            <el-date-picker
              v-model="value1"
              type="date"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </div>
          <div class="repeatbtn">
            <img
              src="../../assets/img/rightsideber/repeat.png"
              alt=""
              @click.stop="repeatclick"
            />
            <span v-show="repeatnumb != 1" style="white-space: nowrap">{{
              repeatitem[repeatnumb - 1]
            }}</span>
            <div class="radio_overfl" :class="dispno ? 'disbl' : ''">
              <template>
                <el-radio-group v-model="repeatnumb" class="radio_lisi">
                  <el-radio
                    class="radio_lisi_item"
                    :label="index + 1"
                    v-for="(item, index) in repeatitem"
                    :key="index"
                    >{{ item }}</el-radio
                  >
                </el-radio-group>
              </template>
              <div
                class="deletesp"
                @click="repeatnumb = 1"
                v-show="repeatnumb != 1"
              >
                <img src="../../assets/img/home/center/deleter.png" alt="" />
                <p>删除重复</p>
              </div>
            </div>
          </div>
          <div class="fourbtn">
            <img
              src="../../assets/img/rightsideber/setquadrant.png"
              alt=""
              @click.stop="fourclick"
            />
            <span v-show="fournumb != 4" style="white-space: nowrap">{{
              fourtitem[fournumb - 1]
            }}</span>
            <div class="radio_overf2" :class="fourdisp ? 'disbl' : ''">
              <template>
                <el-radio-group v-model="fournumb" class="radio_lisi">
                  <el-radio
                    class="radio_lisi_item"
                    :label="index + 1"
                    v-for="(item, index) in fourtitem"
                    :key="index"
                    >{{ item }}</el-radio
                  >
                </el-radio-group>
              </template>
              <div
                class="deletesp"
                @click="fournumb = 4"
                v-show="fournumb != 4"
              >
                <img src="../../assets/img/home/center/deleter.png" alt="" />
                <p>删除象限</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 右侧边栏 -->
    <div v-if="alltodoItem && mask" class="maskdiv" @click="clickmask"></div>
    <div class="rightcontent" ref="rightcpnts">
      <el-drawer
        :visible.sync="alltodoItem"
        :with-header="false"
        :before-close="handleClose"
        size="288px"
        :modal="false"
      >
        <right-sideber
          @todorigClick="sonPackup()"
          @refreshData="delet()"
          :detatodo="detailsTodo"
        ></right-sideber>
      </el-drawer>
    </div>
    <!-- 左侧边栏 -->
    <el-drawer
      :visible.sync="drawer"
      :with-header="false"
      direction="ltr"
      size="288px"
    >
      <left-nav></left-nav>
    </el-drawer>
  </div>
</template>

<script>
import rightSideber from "../../components/content/rightSideber";
import leftNav from "../../components/content/leftNav";
import bus from "./../../util/bus";
import {mapGetters} from 'vuex'
export default {
  components: {
    rightSideber,
    leftNav,
  },
  data() {
    return {
      value1: this.getTime(),
      //控制右侧边栏
      alltodoItem: false,
      //控制显示隐藏
      switchVal: false,
      //传过来的标题
      bgtet: "",
      bgcolo: "",
      //当前点击项
      eegt: "",
      itemdata: [],
      visible: false,
      tranLeft: "",
      tranTop: "",
      addbottom: "",
      indexlist: -1,
      //传给右侧边栏的
      detailsTodo: {},
      //控制重复按钮
      dispno: false,
      repeatnumb: 1,
      repeatitem: ["无", "每天", "每周工作日", "每周", "每月", "每年"],
      //控制选择四象限按钮
      fourdisp: false,
      fournumb: 4,
      fourtitem: ["重要紧急", "重要不紧急", "不重要紧急", "不重要不紧急"],
      //控制点击完成动画
      deleLine: -1,
      //nav的颜色
      fontcolor: false,
      bgcolor: "",
      drawer: false,
      mask: false,
      drawer: false,
      widthvul: 0,
      maskcli: false,
    };
  },
  created() {
    this.bgtet = this.$route.query.tet;
    this.fourdata(this.bgtet);

    this.bgcolor = localStorage.getItem("bgcol");
  },
  watch: {
    $route(val) {
      this.bgtet = this.$route.query.tet;
      this.fourdata(this.bgtet);
    },
    widthvul(vul) {
      console.log(vul, "==========================");
      if (vul <= 1000) {
        console.log(vul, "xiaoyu");
        this.mask = true;
      } else {
        console.log(vul, "dayu");
        this.mask = false;
      }
      console.log(this.mask, "5555555555555555");
    },
  },
  mounted() {
    bus.$on("widthpm", (vul) => {
      console.log(typeof vul, "index.vue传过来的宽度");
      this.widthvul = vul;
    });
  },
  methods: {
    ...mapGetters('theme', ['getThemeStyle', 'getTheme']),
    //左边显示
    displayleft() {
      if (document.body.clientWidth <= 1200) {
        this.drawer = true;
      }
    },
    clickmask() {
      this.maskcli = true;
    },
    handleClose() {
      this.alltodoItem = false;
      this.$refs.soncpnts.style.width = "100%";
      this.$refs.rightcpnts.style.display = "none";
    },
    //请求数据
    fourdata(tet) {
      console.log(this.bgtet, "请求数据");
      //刷新左侧边栏
      bus.$emit("refreshLeft");
      if (tet == "重要紧急") {
        this.forudt(0);
        this.bgcolo = "#ec7259";
        this.fontcolor = true;
      } else if (tet == "重要不紧急") {
        this.forudt(1);
        this.bgcolo = "#f6a801";
        this.fontcolor = true;
      } else if (tet == "不重要紧急") {
        this.forudt(2);
        this.bgcolo = "#b78efc";
        this.fontcolor = true;
      } else if (tet == "不重要不紧急") {
        this.forudt(3);
        this.bgcolo = "#90d034";
        this.fontcolor = true;
      } else if (tet == "今天") {
        this.today();
        this.bgcolo = this.bgcolor;
        this.fontcolor = false;
      }else if (tet == "已过期") {
        this.unday();
        this.bgcolo = this.bgcolor;
        this.fontcolor = false;
      } else if (tet == "未来七天") {
        this.bgcolo = this.bgcolor;
        this.futureday();
        this.fontcolor = false;
      } else if (tet == "自定义") {
        this.bgcolo = this.bgcolor;
        console.log(this.$route.query);
        this.bgtet = this.$route.query.name;
        this.futurcustom(this.$route.query.from_id);
        this.fontcolor = false;
      }
    },
    delet() {
      console.log("重新查询");
      this.fourdata(this.$route.query.tet);
    },
    //api查询四象限
    forudt(p) {
      let header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
      };
      this.$api
        .fourquadrcation(p, header)
        .then((res) => {
          console.log(res, "ggggggg");
          this.itemdata = res.data.result;
          this.deleLine = -1;
        })
        .catch((err) => {});
    },
    //获取当前时间
    getTime() {
      let date = new Date();
      var seperator1 = "-";
      var seperator2 = ":";
      //以下代码依次是获取当前时间的年月日时分秒
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      var minute = date.getMinutes();
      var hour = date.getHours();
      var second = date.getSeconds();
      //固定时间格式
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      if (hour >= 0 && hour <= 9) {
        hour = "0" + hour;
      }
      if (minute >= 0 && minute <= 9) {
        minute = "0" + minute;
      }
      if (second >= 0 && second <= 9) {
        second = "0" + second;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      // "/" +
      // hour +
      // seperator2 +
      // minute +
      // seperator2 +
      // second;
      return currentdate;
    },
    //查询今天的清单
    today() {
      let header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
      };
      this.$api
        .todaytwo(this.getTime(), header)
        .then((res) => {
          console.log("今天请求到的数据");
          this.itemdata = res.data.results;
          this.deleLine = -1;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //查询已过期的清单
    unday() {
      let header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
      };
      // let data = {
      //   task_status: false,
      //   user:sessionStorage.getItem("userid"),
      //   range_task_time_before:this.getTime(),
      // }
      this.$api
        .unday('',header)
        .then((res) => {
          console.log(res,"请求到的已过期数据");
          this.itemdata = res.data.result;
          this.deleLine = -1;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //查询未来七天的清单
    futureday() {
      let header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
      };
      this.$api
        .futureday("", header)
        .then((res) => {
          console.log("未来七天数据");
          this.itemdata = res.data.result;
          this.deleLine = -1;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //查询自定义清单
    futurcustom(index) {
      console.log(index, "清单id");
      let header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
      };
      this.$api
        .customquadrcation(index, header)
        .then((res) => {
          console.log(res, "自定义清单的");
          this.itemdata = res.data.result;
          this.deleLine = -1;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 显示隐藏
    switchChang(e) {
      console.log(e, "点击的switch的值");
      this.switchVal = e;
    },
    //清单条目点击事件
    todorigClick(index, item) {
      console.log(index, "点击了");
      if (this.eegt != index) {
        this.alltodoItem = true;
        this.sideWidth(item);
        this.eegt = index;
      } else {
        this.alltodoItem = !this.alltodoItem;
        this.sideWidth(item);
      }
    },
    //点击已完成
    chooseCheak(item, index) {
      console.log(index, 77777777);
      this.deleLine = index;
      var that = this;
      setTimeout(function () {
        let header = {
          Authorization: "Bearer " + localStorage.getItem("token"),
        };
        let data = {
          todo_id: item.id,
        };
        that.$api
          .completed(data, header)
          .then((res) => {
            that.fourdata(that.$route.query.tet);
            console.log(res, "点击已完成", that.$route.query.tet);
            this.deleLine = -1;
          })
          .catch((err) => {
            console.log(err);
          });
      }, 1000);
    },
    addsubmit(data) {
      let header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
      };

      this.$api
        .releasetodo(data, header)
        .then((res) => {
          console.log(res, "发布清单");
          this.fourdata(this.$route.query.tet);
          this.addbottom = "";
          this.fournumb = 4;
          this.repeatnumb = 1;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //发布清单
    submit() {
      if (this.addbottom != "") {
        console.log(this.$route.query.tet);
        if (this.$route.query.tet == "自定义") {
          console.log("自定义");
          if (this.value1 == "") {
            let data = {
              task_name: this.addbottom,
              type: this.fournumb - 1,
              task_repeat: this.repeatnumb - 1,
              todo_from: this.$route.query.from_id,
            };
            this.addsubmit(data);
          } else {
            let data = {
              task_name: this.addbottom,
              type: this.fournumb - 1,
              task_repeat: this.repeatnumb - 1,
              task_time: this.value1,
              todo_from: this.$route.query.from_id,
            };
            this.addsubmit(data);
          }
        } else if (this.$route.query.tet == "今天") {
          console.log("发布今天的清单");
          if (this.value1 == "") {
            let data = {
              task_name: this.addbottom,
              type: this.fournumb - 1,
              task_repeat: this.repeatnumb - 1,
              task_time: this.getTime(),
            };
            console.log(data, "发布今天的清单");
            this.addsubmit(data);
          } else {
            let data = {
              task_name: this.addbottom,
              type: this.fournumb - 1,
              task_repeat: this.repeatnumb - 1,
              task_time: this.value1,
            };
            console.log(data, "发布今天的清单");
            this.addsubmit(data);
          }
        } else {
          console.log("不是自定义");
          if (this.value1 == "") {
            console.log("没有时间");
            let data = {
              task_name: this.addbottom,
              type: this.fournumb - 1,
              task_repeat: this.repeatnumb - 1,
            };
            this.addsubmit(data);
          } else {
            console.log("有时间");
            let data = {
              task_name: this.addbottom,
              type: this.fournumb - 1,
              task_repeat: this.repeatnumb - 1,
              task_time: this.value1,
            };
            this.addsubmit(data);
          }
        }
        console.log(this.value1, "发布");
      }
    },
    //重复按钮
    repeatclick() {
      console.log(this.dispno);
      this.dispno = !this.dispno;
      this.fourdisp = false;
    },
    //选择象限按钮
    fourclick() {
      this.fourdisp = !this.fourdisp;
      this.dispno = false;
    },
    sonPackup() {
      this.alltodoItem = false;
      this.sideWidth();
    },
    //全部待办点击事件
    sideWidth(item) {
      if (document.body.clientWidth <= 1000) {
        this.mask = true;
      }
      if (this.alltodoItem) {
        this.$refs.soncpnts.style.width = "calc(100% - 286px)";
        this.$refs.rightcpnts.style.display = "block";
        console.log(item);
        this.detailsTodo = item;
        console.log(this.detailsTodo, "oooooooo");
      } else {
        this.$refs.soncpnts.style.width = "100%";
        this.$refs.rightcpnts.style.display = "none";
      }
    },

    show111(e, index) {
      console.log(index, this.indexlist);
      if (index == this.indexlist) {
        this.visible = false;
        // this.visible = true
      } else {
        this.indexlist = index;
        this.visible = true;
      }
      let tlet = document.getElementsByClassName("idpop");
      console.log(tlet);
      this.tranLeft = e.pageX - 300 + "px";
      this.tranTop = e.pageY + "px";
    },
    homeclick() {
      this.visible = false;
      this.dispno = false;
      this.fourdisp = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.fourlist {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  display: flex;
  .maskdiv {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #808080;
    opacity: 0.6;
    z-index: 99;
  }
  .navlef {
    width: 19%;
  }
  .rightcontent {
    width: 286px;
    height: 100%;
    display: none;
    .el-drawer__open .el-drawer.rtl {
      -webkit-animation: none !important;
      animation: none !important;
    }
  }
  .nav {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 50px;
    margin-bottom: 10px;
    height: 40px;
    padding: 0 4%;

    &-lt {
      display: flex;
      align-items: center;
      &-img {
        width: 20px;
        height: 16px;
        margin: 0 35px 0 0;
      }

      &-tit {
        font-size: 30px;
        font-weight: bold;
        color: #333333;
      }
    }

    &-rt {
      display: flex;
      align-items: center;

      &-sw {
        width: 33px;
        height: 16px;
        span {
          height: 16px;
        }

        .el-switch__core {
          height: 16px !important;
        }
        .el-switch__core::after {
          height: 13px !important;
          width: 13px !important;
        }
      }

      &-txt {
        font-size: 16px;
        color: #666666;
        margin: 0 0 0 6px;
      }
    }
  }
  .foncolor {
    .nav-lt-tit {
      color: #fff;
    }
    .nav-rt-txt {
      color: #fff;
    }
  }
  .alltodo {
    position: relative;
    width: 100%;
    height: 100%;
    background-color: var(--color-theme);
    .height-cotr {
      height: calc(100% - 200px);
      overflow-y: auto;
      padding: 0 4%;
    }
    .height-cotr::-webkit-scrollbar {
      width: 4px;
    }
    .height-cotr::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background: rgba(0, 0, 0, 0.2);
    }
    .idpop {
      position: absolute;
      z-index: 2000;
      height: 50px;
      width: 210px;
      background-color: #fff;
      box-shadow: 0px 4px 32px 3px rgba(0, 0, 0, 0.19);
      display: flex;
      align-items: center;
      img {
        margin: 0 30px;
      }
    }
    .add_task {
      display: flex;
      align-items: center;
      width: 90%;
      margin: 20px auto;
      height: 57px;
      border-radius: 7px;
      background-color: #cee8e8;
      padding: 0 3%;
      img {
        width: 16px;
        height: 16px;
        margin-right: 20px;
      }
      input {
        width: 100%;
        height: 100%;
        border: none;
        border-radius: 7px;
        background-color: #cee8e8;
        font-size: 16px;
      }
      input::-webkit-input-placeholder {
        color: #00a68a;
      }
      .add_task_right {
        display: flex;
        font-size: 15px;
        color: #333;
        .newlybuild_time {
          position: relative !important;
          .el-date-editor {
            width: auto !important;
            position: absolute !important;
            top: 0 !important;
            left: 0 !important;
            opacity: 0;
          }
        }

        .disbl {
          display: block !important;
        }
        .radio_lisi {
          display: flex;
          flex-direction: column;
          .el-radio {
            padding: 0;
            margin-left: 30px;
          }
          .radio_lisi_item {
            text-align: left;
            line-height: 35px;
            font-size: 14px;
          }
        }
        .deletesp {
          display: flex;
          width: 100%;
          align-items: center;
          padding-left: 30px;
          color: #dc282b;
          margin: 8px 0;
          img {
            width: 15px;
            height: 15px;
            margin: 0 8px 0 0;
          }
        }
        .repeatbtn {
          position: relative;

          .radio_overfl {
            display: none;
            position: absolute;
            bottom: 20px;
            width: 180px;
            height: auto;
            background-color: #fff;
            z-index: 50;
            box-shadow: 0px 4px 32px 3px rgba(0, 0, 0, 0.19);
            font-size: 15px;
          }
        }
        .fourbtn {
          position: relative;
          .radio_overf2 {
            display: none;
            position: absolute;
            font-size: 15px;
            bottom: 20px;
            width: 180px;
            height: auto;
            background-color: #fff;
            z-index: 50;
            box-shadow: 0px 4px 32px 3px rgba(0, 0, 0, 0.19);
          }
        }
        div {
          display: flex;
          img {
            width: 18px;
            height: 18px;
            margin: 0 8px;
          }
        }
      }
    }
    .bgncolor {
      background-color: #fff;
      input {
        background-color: #fff;
      }
    }

    .alltodo_content {
      .center_title {
        display: block;
        width: 100%;
        text-align: center;
        margin: 15px 0;
      }
      .alltodo_outer {
        width: 100%;
      }
      .alltodo_list {
        display: flex;
        align-items: center;
        border-radius: 7px;
        width: 100%;
        background-color: #fff;
        height: 57px;
        margin: 20px 0;
        overflow: hidden;
        i {
          display: block;
          width: 3px;
          height: 18px;
          background-color: #90d034;
          margin-left: 10px;
        }
        .min_img {
          width: 21px;
          height: 21px;
          margin: 0 20px;
        }
        .min_list {
          .alltodo_list_content {
            font-size: 15px;
          }
          div {
            display: flex;
            margin-top: 8px;
            font-size: 13px;
            img {
              margin-left: 12px;
            }
          }
        }
      }
      .delecls {
        text-decoration: line-through;
        opacity: 0.6;
        width: 0;
        padding: 0;
        transition: width 1s linear;
      }
    }
    .main_bt_img {
      width: 100%;
      text-align: center;
      margin-top: 15%;
      img {
        width: 280px;
        height: 215px;
      }
    }
  }
}
</style>